import React from 'react';

export const ShareFilledSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_23677_19507)">
      <path
        d="M15.8594 13.4688C14.7015 13.4688 13.6812 14.0383 13.0404 14.9045L7.49961 12.0673C7.5916 11.7538 7.65625 11.4288 7.65625 11.0859C7.65625 10.6209 7.5609 10.1787 7.39617 9.77203L13.1948 6.28266C13.8401 7.04 14.7886 7.53125 15.8594 7.53125C17.798 7.53125 19.375 5.95426 19.375 4.01562C19.375 2.07699 17.798 0.5 15.8594 0.5C13.9207 0.5 12.3438 2.07699 12.3438 4.01562C12.3438 4.46238 12.4357 4.88617 12.5884 5.27961L6.77246 8.77922C6.1277 8.04437 5.19285 7.57031 4.14062 7.57031C2.20199 7.57031 0.625 9.1473 0.625 11.0859C0.625 13.0246 2.20199 14.6016 4.14062 14.6016C5.31758 14.6016 6.35512 14.0153 6.99356 13.1248L12.5161 15.9527C12.4143 16.2811 12.3438 16.623 12.3438 16.9844C12.3438 18.923 13.9207 20.5 15.8594 20.5C17.798 20.5 19.375 18.923 19.375 16.9844C19.375 15.0457 17.798 13.4688 15.8594 13.4688Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_23677_19507">
        <rect width="20" height="20" fill="currentColor" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default ShareFilledSvg;
